import React, { useContext, createContext, useState } from "react";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
    const [searchData, setSearchData] = useState("");
    const [filtersubCategory, setsubCategory] = useState("");
    const [filter, setFilter] = useState(null); 
    const [searchAllCategories, setSearchAllCategories] = useState(false);
    //const [filter, setFilter] = useState("0");

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    }

    const handleSearchChange = (e) => {
        setSearchData(e.target.value);
    }
    const handleSubCategoryChange = (name) => {
        // console.log(name);
        setsubCategory(name);
    }
    

   

    const isAllSelected = filter === "0" && (!searchData|| !filtersubCategory);

    return (
        <SearchContext.Provider value={{
            searchData,
            filtersubCategory,
            setSearchData,
            setFilterSubCategory: setsubCategory,
            handleSearchChange,
            filter,
            handleFilterChange,
            isAllSelected,
            handleSubCategoryChange,
            setFilter,
            searchAllCategories,
            setSearchAllCategories,
        }}>
            {children}
        </SearchContext.Provider>
    )
}

export const useSearch = () => {
    const context = useContext(SearchContext);
    if (!context) {
        throw new Error('useSearch must be used within a CartProvider');
    }
    return context;
}

 



